import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditInvitationSponsoredRegister from '../edit/EditInvitationSponsoredRegister';
import { DialogContent, DialogTitle } from '@mui/material';
import DialogBase from './DialogBase';

class DialogEditInvitationSponsoredRegister extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-invitation-sponsored-register";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>Invitation</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditInvitationSponsoredRegister
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditInvitationSponsoredRegister.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditInvitationSponsoredRegister);
